import Alicante from 'url:./Alicante.png'
import Barcelona from 'url:./Barcelona.png'
import Barcelona1 from 'url:./Barcelona1.png'
import Barcelona2 from 'url:./Barcelona2.png'
import Berlin from 'url:./Berlin.png'
import Berlin2 from 'url:./Berlin2.png'
import Berlin3 from 'url:./Berlin3.png'
import Bettendorf from 'url:./Bettendorf.png'
import Birmingham from 'url:./Birmingham.png'
import Birmingham2 from 'url:./Birmingham2.png'
import Bremen from 'url:./Bremen.png'
import Chicago from 'url:./Chicago.png'
import Copenhagen from 'url:./Copenhagen.png'
import Copenhagen1 from 'url:./Copenhagen1.png'
import Copenhagen2 from 'url:./Copenhagen2.png'
import Dallas from 'url:./Dallas.png'
import Denver from 'url:./Denver.png'
import Edinburgh from 'url:./Edinburgh.png'
import Edinburgh1 from 'url:./Edinburgh1.png'
import ForthWorth from 'url:./FortWorth.png'
import ForthWorth1 from 'url:./FortWorth1.png'
import Helsinki from 'url:./Helsinki 1.png'
import Helsinki1 from 'url:./Helsinki 5.png'
import Helsinki2 from 'url:./Helsinki 6.png'
import Helsinki3 from 'url:./Helsinki 7.png'
import Izumo from 'url:./Izumo.png'
import Izumo1 from 'url:./Izumo1.png'
import Kamloops from 'url:./Kamloops.png'
import Kyiv from 'url:./Kyiv.png'
import Kyiv1 from 'url:./Kyiv1.png'
import Kyiv2 from 'url:./Kyiv2.png'
import Leipzig2 from 'url:./Leipzig2.png'
import Leipzig3 from 'url:./Leipzig3.png'
import London from 'url:./London.png'
import LosAngeles from 'url:./LosAngeles.png'
import LosAngeles1 from 'url:./LosAngeles1.png'
import LosAngeles2 from 'url:./LosAngeles2.png'
import Manchester from 'url:./Manchester.png'
import Milan from 'url:./Milan.png'
import Milan1 from 'url:./Milan1.png'
import Munich from 'url:./Munich.png'
import Munich2 from 'url:./Munich2.png'
import Munich3 from 'url:./Munich3.png'
import Munich4 from 'url:./Munich4.png'
import NewYork from 'url:./NewYork.png'
import NewYork1 from 'url:./NewYork1.png'
import Oestersund from 'url:./Oestersund.png'
import Oestersund1 from 'url:./Oestersund1.png'
import Oslo from 'url:./Oslo.png'
import Oslo1 from 'url:./Oslo1.png'
import Ottawa1 from 'url:./Ottawa1.png'
import Ottawa14th1 from 'url:./Ottawa14th1.png'
import Ottawa14th2 from 'url:./Ottawa14th2.png'
import Ottawa2 from 'url:./Ottawa2.png'
import Ottawa3 from 'url:./Ottawa3.png'
import Paris1 from 'url:./Paris1.png'
import Paris2 from 'url:./Paris2.png'
import Plovdiv from 'url:./Plovdiv.png'
import Plovdiv1 from 'url:./Plovdiv2.png'
import Prague from 'url:./Prague.png'
import Prague1 from 'url:./Prague1.png'
import Rosendal from 'url:./Rosendal.png'
import SanAndres from 'url:./SanAndres.png'
import SanAndres1 from 'url:./SanAndres1.png'
import Seattle from 'url:./Seattle.png'
import Seattle1 from 'url:./Seattle1.png'
import SF from 'url:./SF.png'
import SF1 from 'url:./SF1.png'
import Sydney from 'url:./Sydney.png'
import Sydney1 from 'url:./Sydney1.png'
import Sydney2 from 'url:./Sydney2.png'
import Tallinn from 'url:./Tallinn.png'
import Tarragona from 'url:./Tarragona.png'
import Tarragona1 from 'url:./Tarragona1.png'
import Tarragona2 from 'url:./Tarragona2.png'
import Tarragona3 from 'url:./Tarragona3.png'
import Tbilisi from 'url:./Tbilisi.png'
import Tbilisi1 from 'url:./Tbilisi1.png'
import Tbilisi2 from 'url:./Tbilisi2.png'
import Tbilisi3 from 'url:./Tbilisi3.png'
import TheHague from 'url:./The Hague.png'
import Tranas from 'url:./Tranas.png'
import Vienna from 'url:./Vienna.png'
import Vienna1 from 'url:./Vienna1.png'
import Vienna2 from 'url:./Vienna2.png'
import Vienna3 from 'url:./Vienna3.png'
import Vienna4 from 'url:./Vienna4.png'
import Vienna5 from 'url:./Vienna5.png'
import Washington from 'url:./Washington.png'
import Washington1 from 'url:./Washington1.png'
import Wroclaw from 'url:./Wroclaw.png'
import Wroclaw1 from 'url:./Wroclaw1.png'
import { shuffle } from '../../utils/helpers'

export const photos = [
  { src: Alicante, city: 'alicante', country: 'spain' },
  { src: Barcelona, city: 'barcelona', country: 'spain' },
  { src: Barcelona1, city: 'barcelona', country: 'spain' },
  { src: Barcelona2, city: 'barcelona', country: 'spain' },

  { src: Berlin, city: 'berlin', country: 'germany' },
  { src: Berlin2, city: 'berlin', country: 'germany' },
  { src: Berlin3, city: 'berlin', country: 'germany' },

  { src: Bettendorf, city: 'bettendorf', country: 'usa' },

  { src: Birmingham, city: 'birmingham', country: 'unitedKingdom' },
  { src: Birmingham2, city: 'birmingham', country: 'unitedKingdom' },

  { src: Bremen, city: 'bremen', country: 'germany' },

  { src: Chicago, city: 'chicago', country: 'united states' },

  { src: Copenhagen, city: 'copenhagen', country: 'denmark' },
  { src: Copenhagen1, city: 'copenhagen', country: 'denmark' },
  { src: Copenhagen2, city: 'copenhagen', country: 'denmark' },

  { src: Dallas, city: 'dallas', country: 'usa' },

  { src: Denver, city: 'denver', country: 'usa' },

  { src: Edinburgh, city: 'edinburgh', country: 'united kingdom' },
  { src: Edinburgh1, city: 'edinburgh', country: 'united kingdom' },

  { src: ForthWorth, city: 'fortWorth', country: 'usa' },
  { src: ForthWorth1, city: 'fortWorth', country: 'usa' },

  { src: Helsinki, city: 'helsinki', country: 'finland' },
  { src: Helsinki1, city: 'helsinki', country: 'finland' },
  { src: Helsinki2, city: 'helsinki', country: 'finland' },
  { src: Helsinki3, city: 'helsinki', country: 'finland' },

  { src: Izumo, city: 'izumo14', country: 'japan' },
  { src: Izumo1, city: 'izumo20', country: 'japan' },

  { src: Kamloops, city: 'kamloops', country: 'canada' },

  { src: Kyiv, city: 'kyiv', country: 'ukraine' },
  { src: Kyiv1, city: 'kyiv', country: 'ukraine' },
  { src: Kyiv2, city: 'kyiv', country: 'ukraine' },

  { src: Leipzig2, city: 'leipzig', country: 'germany' },
  { src: Leipzig3, city: 'leipzig', country: 'germany' },

  { src: London, city: 'london', country: 'unitedKingdom' },

  { src: LosAngeles, city: 'losAngeles', country: 'usa' },
  { src: LosAngeles1, city: 'losAngeles', country: 'usa' },
  { src: LosAngeles2, city: 'losAngeles', country: 'usa' },

  { src: Manchester, city: 'manchester', country: 'unitedKingdom' },

  { src: Milan, city: 'milan', country: 'italy' },
  { src: Milan1, city: 'milan', country: 'italy' },

  { src: Munich, city: 'munich', country: 'germany' },
  { src: Munich2, city: 'munich', country: 'germany' },
  { src: Munich3, city: 'munich', country: 'germany' },
  { src: Munich4, city: 'munich', country: 'germany' },

  { src: NewYork, city: 'newYork13', country: 'usa' },
  { src: NewYork1, city: 'newYork13', country: 'usa' },

  { src: Oestersund, city: 'ostersund', country: 'sweden' },
  { src: Oestersund1, city: 'ostersund', country: 'sweden' },

  { src: Oslo, city: 'oslo', country: 'norway' },
  { src: Oslo1, city: 'oslo', country: 'norway' },

  { src: Ottawa1, city: 'ottawa12', country: 'canada' },
  { src: Ottawa2, city: 'ottawa12', country: 'canada' },
  { src: Ottawa3, city: 'ottawa12', country: 'canada' },
  { src: Ottawa14th1, city: 'ottawa13', country: 'canada' },
  { src: Ottawa14th2, city: 'ottawa13', country: 'canada' },

  { src: Paris1, city: 'paris', country: 'france' },
  { src: Paris2, city: 'paris', country: 'france' },

  { src: Plovdiv, city: 'plovdiv', country: 'bulgaria' },
  { src: Plovdiv1, city: 'plovdiv', country: 'bulgaria' },

  { src: Prague, city: 'prague', country: 'czechia' },
  { src: Prague1, city: 'prague', country: 'czechia' },

  { src: Rosendal, city: 'rosendal', country: 'southAfrica' },

  { src: SanAndres, city: 'sanAndres', country: 'colombia' },
  { src: SanAndres1, city: 'sanAndres', country: 'colombia' },

  { src: Seattle, city: 'seattle', country: 'usa' },
  { src: Seattle1, city: 'seattle', country: 'usa' },

  { src: SF, city: 'sanFrancisco', country: 'usa' },
  { src: SF1, city: 'sanFrancisco', country: 'usa' },

  { src: Sydney, city: 'sydney', country: 'australia' },
  { src: Sydney1, city: 'sydney', country: 'australia' },
  { src: Sydney2, city: 'sydney', country: 'australia' },

  { src: Tallinn, city: 'tallinn', country: 'estonia' },

  { src: Tarragona, city: 'tarragona', country: 'spain' },
  { src: Tarragona1, city: 'tarragona', country: 'spain' },
  { src: Tarragona2, city: 'tarragona', country: 'spain' },
  { src: Tarragona3, city: 'tarragona', country: 'spain' },

  { src: Tbilisi, city: 'tbilisi', country: 'georgia' },
  { src: Tbilisi1, city: 'tbilisi', country: 'georgia' },
  { src: Tbilisi2, city: 'tbilisi', country: 'georgia' },
  { src: Tbilisi3, city: 'tbilisi', country: 'georgia' },

  { src: TheHague, city: 'theHague', country: 'netherlands' },

  { src: Tranas, city: 'tranas', country: 'sweden' },

  { src: Vienna, city: 'vienna', country: 'austria' },
  { src: Vienna1, city: 'vienna', country: 'austria' },
  { src: Vienna2, city: 'vienna', country: 'austria' },
  { src: Vienna3, city: 'vienna', country: 'austria' },
  { src: Vienna4, city: 'vienna', country: 'austria' },
  { src: Vienna5, city: 'vienna', country: 'austria' },

  { src: Washington, city: 'washingtonDC', country: 'usa' },
  { src: Washington1, city: 'washingtonDC', country: 'usa' },

  { src: Wroclaw, city: 'wroclaw', country: 'poland' },
  { src: Wroclaw1, city: 'wroclaw', country: 'poland' },
]

export const ralliesPhotos = shuffle(photos)
